/*
 * @Author: wuzhen wz0309@163.com
 * @Date: 2023-11-22 09:07:34
 * @LastEditors: lwk
 * @LastEditTime: 2024-02-28 10:41:00
 * @FilePath: \eiiplat_front\src\api\console.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import request from "@/utils/request";

export function getUserInfo() {
  return request({
    url: "/pt/tenant/getMyTenantInfo",
    method: "post"
  })
}
// 获取部门得分排名
export function getexportDepartmentData(params) {
  return request({
    url: "/twoday/getDepartmentData",
    method: "get",
    params
  })
}
// 查询经理点赞排名
export function getDepartmentManagerData(params) {
  return request({
    url: "/twoday/getDepartmentManagerData",
    method: "get",
    params
  })
}
// 查询部门全体员工发布
export function getEmployeeData(params) {
  return request({
    url: "/twoday/getEmployeeData",
    method: "get",
    params
  })
}
// 查询部门个体员工发布
export function getEmployeeDayData(params) {
  return request({
    url: "/twoday/getEmployeeDayData",
    method: "get",
    params
  })
}
// 导出部门全体员工发布
export function exportEmployeeData(params) {
  return request({
    url: "/twoday/exportEmployeeData",
    method: "get",
    responseType: 'blob',
    params
  })
}
// 导出部门个体员工发布
export function exportEmployeeDayData(params) {
  return request({
    url: "/twoday/exportEmployeeDayData",
    method: "get",
    responseType: 'blob',
    params
  })
}

// 获取获奖列表
export function getAwardList (params){
  return request({
    url:"/twoday/getAwardsPage",
    method:"get",
    params
  })
}

// 新增获奖列表
export function addAwardList (data){
  return request({
    url:"/twoday/awards",
    method:"post",
    data
  })
}

// 部门获奖排名echart
export function getDepartmentAwards (params){
  return request({
    url:"/twoday/getDepartmentAwards",
    method:"get",
    params
  })
}
// 个人获奖排名echart
export function getEmployeeAwards (params){
  return request({
    url:"/twoday/getEmployeeAwards",
    method:"get",
    params
  })
}

// 根据邮箱获取用户信息
export function getEmail(params) {
  return request({
    url: "/twoday/employee/email",
    method: "get",
    params
  })
}
// 日行一善全部帖子
export function getAllPage(params) {
  return request({
    url: "/twoday/log_views_page",
    method: "get",
    params
  })
}
// 日行一善cm帖子
export function getCmPage(params) {
  return request({
    url: "/twoday/log_one_page",
    method: "get",
    params
  })
}
// 日行一善点赞点low帖子
export function commentItem(params) {
  return request({
    url: "/twoday/comment",
    method: "post",
    data:params
  })
}
// 日行一善取消点赞点low帖子
export function delCommentItem(params) {
  return request({
    url: "/twoday/comment",
    method: "delete",
    params
  })
}
// 日行一善帖子详情
export function getCmPageDetail(params) {
  return request({
    url: "/twoday/log_views/"+params.logId,
    method: "get",
    params
  })
}
// 日行一善发表个人帖子
export function releaseLog(params) {
  return request({
    url: "/twoday/log",
    method: "post",
    data:params
  })
}


// WEBPACK FOOTER //
// ./src/api/doOneGood.js